import { useLocalPartnerIntent } from "@/hooks/useLocalPartnerIntent";

// The endsAt mirrors the backend's PROMOTIONAL_ACCESS_ENDS_AT (Pacific midnight on the end date) - keep these in sync.
// Workwhile intentionally has no endsAt because our partnership with them cuts over to charging Workwhile, not the user.
const PROMO_PARTNERS: Record<string, { name: string; endsAt?: string }> = {
  walmart: { name: "Walmart", endsAt: "2026-08-03T00:00:00-07:00" },
  sams_club: { name: "Sam's Club", endsAt: "2026-12-01T00:00:00-08:00" },
  workwhile: { name: "WorkWhile" },
};

// Display name to optimistically present a stored partner intent as covering the visit, gated on the
// partner's promotional window still being open. Returns null while the intent resolves, or when it
// isn't a promoted partner / its promo has ended.
export const useLocalPartnerName = (): string | null => {
  const partner = useLocalPartnerIntent();
  const promo = partner ? PROMO_PARTNERS[partner] : undefined;
  if (!promo || (promo.endsAt && Date.now() > Date.parse(promo.endsAt))) {
    return null;
  }
  return promo.name;
};
